export default __webpack_public_path__ + "b94b76f2edf056c52261e99bb69e5b09.svg";